import classNames from 'classnames'
import { ReactNode, FC, useState, useEffect } from 'react'

import { Icon, Placeholder } from '~ui'

import styles from './Accordion.module.scss'

type AccordionProps = {
  openHeader: ReactNode
  closeHeader?: ReactNode
  body: ReactNode
  onOpen?: () => void
  isOpen?: boolean
  wrapperClasses?: string
  loading?: boolean
}

const Accordion: FC<AccordionProps> = ({
  openHeader,
  closeHeader,
  body,
  onOpen,
  isOpen,
  loading,
  wrapperClasses,
}) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(isOpen)

  useEffect(() => {
    if (onOpen) {
      setIsAccordionOpen(isOpen)
    }
  }, [isOpen])

  return (
    <div className={classNames(styles.accordion, wrapperClasses)}>
      <button
        type="button"
        className={styles['header-button']}
        onClick={() => (onOpen ? onOpen() : setIsAccordionOpen((prevOpen) => !prevOpen))}
        disabled={loading}
      >
        {isAccordionOpen ? openHeader : closeHeader || openHeader}
        {!loading ? (
          <Icon
            name="dropdown"
            style={{ transform: isAccordionOpen ? 'rotateX(180deg)' : 'unset' }}
          />
        ) : (
          <Placeholder style={{ marginLeft: 'auto', width: 30, height: 30, borderRadius: '50%' }} />
        )}
      </button>

      <div
        className={styles.body}
        style={{
          display: isAccordionOpen ? 'initial' : 'none',
        }}
      >
        <div className={styles.content}>
          <div className={styles.separator} />
          {body}
        </div>
      </div>
    </div>
  )
}

export default Accordion
